<template>
    <div id="calendar-deleted">
        <h2><span>Declined</span></h2>

        <table class="calendar-deleted-list table">
            <tr>
                <th class="calendar-queued-status">
                    <SortableHeader :active="'status' == key" :asc="ascending"
                        @click="doSortBy('status')"
                    ><QuestionFill /></SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'name' == key" :asc="ascending"
                        @click="doSortBy('name')"
                    >Name</SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'org' == key" :asc="ascending"
                        @click="doSortBy('org')"
                    >Organisation</SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'date' == key" :asc="ascending"
                        @click="doSortBy('date')"
                    >Sent</SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'deleted' == key" :asc="ascending"
                        @click="doSortBy('deleted')"
                    >Declined</SortableHeader>
                </th>
            </tr>
            <tr v-for="(item, index) in sorted" :key="`item${index}`"
                class="calendar-queued-row"
                @click="doModal(item)"
            >
                <td class="calendar-deleted-status">
                    <CalendarIcon :item="item" :me="me" />
                </td>
                <td>{{item.other_name}}

                    <div v-if="item.reschedule_to_id"
                        class="label label-info"
                    >Meeting rescheduled</div>
                </td>
                <td>{{item.other_organisation_name}}</td>
                <td>{{asRelativeDateTime(item.created_at, true)}}</td>
                <td>{{asRelativeDateTime(item.deleted_at, true)}}</td>
            </tr>
        </table>
    
    </div>
</template>

<script>
/** These calendar items must all be DELETED MEETINGS 
 * 
 */
import {ITEM_TYPES} from '@/components/Config';

import QuestionFill from '@/components/icons/QuestionFill';
import SortableHeader from "@/components/table/SortableHeader";
import {asRelativeDateTime} from "@/utils/DateTime";

import {compareBy} from "@/utils/Sort";

import CalendarIcon from './CalendarIcon';

const KEYS = {
    STATUS: 'status',
    NAME: 'name',
    ORG: 'org',
    DATE: 'date',
    DELETED_AT: 'deleted',
};

export default {
    name: "CalendarDeleted",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        toggles: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    data: function() {
        return {
            key: KEYS.DELETED_AT, // DEFAULT SORT ORDER
            ascending: false,
        };
    },
    components: {
        CalendarIcon,
        QuestionFill,
        SortableHeader,
    },
    computed: {
        // filtered() {
        //     // Re-filter the items to just show the slotless ones
        //     return this.items.filter(item => isMeetingSlotless(item));
        // },
        sorted() {
            let copied = [...this.filters.deleted]; // .map(addOther(this.me));
            switch (this.key) {
                case KEYS.NAME:
                    // TODO: Sort by LAST name, not whole name :-/
                    copied.sort(compareBy('other_last_name'));
                    break;
                case KEYS.ORG:
                    copied.sort(compareBy('other_organisation_name'));
                    break;
                case KEYS.DATE:
                    copied.sort(compareBy('created_at'));
                    break;
                case KEYS.STATUS:
                    copied.sort(compareBy('flags'));
            }
            if (!this.ascending) {
                copied.reverse();
            }
            return copied;
        }
    },
    methods: {
        asRelativeDateTime,
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.sorted
            });
        },
        doSortBy(key) {
            if (this.key==key) {
                this.ascending = !this.ascending;
            } else {
                this.key = key
            }
        }
    },
    beforeCreate() {
        this.ITEM_TYPES = ITEM_TYPES;
    },
}
</script>

<style>
#calendar-deleted {
    margin-bottom: 10px;
}

.calendar-deleted-row {
    cursor: pointer;
}

/* Override some bootstrap defaults */
#calendar-deleted .table th {
    border-top: 0;
    padding: 0;
}

</style>